// VAT Toggle - MINIMAL TEST VERSION
// No DOM manipulation, no observers, just click handling and localStorage
const STORAGE_KEY = 'sofia-vat-display-mode';
const ACTIVE_COLOR_VAR = '--sofia-vat-toggle-active-color';

function isVatToggleEnabled() {
  const header =
    document.getElementById('header-component') ||
    document.querySelector('header-component') ||
    document.querySelector('.header') ||
    document.querySelector('header');

  const hasPageToggle = !!document.querySelector('[data-vat-toggle]');

  if (!(header instanceof Element)) return hasPageToggle;

  const enabledAttr = header.getAttribute('data-vat-toggle-enabled');
  if (enabledAttr === 'false' && !hasPageToggle) {
    return false;
  }
  return true;
}

function getEffectiveVatMode() {
  let mode = localStorage.getItem(STORAGE_KEY);
  if (mode !== 'incl' && mode !== 'excl') {
    mode = 'incl';
  }
  if (!isVatToggleEnabled()) {
    mode = 'incl';
  }
  return mode;
}

function syncActiveColorFromHeader() {
  const header =
    document.getElementById('header-component') ||
    document.querySelector('header-component') ||
    document.querySelector('.header') ||
    document.querySelector('header');

  if (!(header instanceof Element)) return;

  const activeColor = header.getAttribute('data-vat-toggle-active-color');
  if (activeColor) {
    document.documentElement.style.setProperty(ACTIVE_COLOR_VAR, activeColor);
  }
}

function applyVatMode(mode) {
  const els = document.querySelectorAll('[data-vat-excl]');
  els.forEach((el) => {
    const excl = el.getAttribute('data-vat-excl');
    const incl = el.getAttribute('data-vat-incl');
    const fromLabel = el.getAttribute('data-vat-from-label');
    
    let priceToDisplay = '';
    if (mode === 'incl' && incl) {
      priceToDisplay = incl;
    } else if (excl) {
      priceToDisplay = excl;
    }
    
    if (fromLabel && priceToDisplay) {
      el.textContent = fromLabel + ' ' + priceToDisplay;
    } else if (priceToDisplay) {
      el.textContent = priceToDisplay;
    }
  });
}

function updateToggleUI(mode) {
  const toggles = document.querySelectorAll('[data-vat-toggle]');
  toggles.forEach((toggle) => {
    const buttons = toggle.querySelectorAll('[data-vat-mode]');
    buttons.forEach((btn) => {
      const btnMode = btn.getAttribute('data-vat-mode');
      const isActive = btnMode === mode;
      btn.classList.toggle('vat-toggle__option--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  });
}

// Simple click handler
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!target || !(target instanceof Element)) return;
  
  const button = target.closest('[data-vat-mode]');
  if (!button) return;
  
  // Skip header toggle (handled by vat-toggle-header.js)
  if (button.closest('.header__vat-toggle')) return;
  
  // Only handle if inside a vat-toggle container
  if (!button.closest('[data-vat-toggle]')) return;

  const newMode = button.getAttribute('data-vat-mode');
  if (newMode !== 'incl' && newMode !== 'excl') return;

  event.preventDefault();
  
  localStorage.setItem(STORAGE_KEY, newMode);
  applyVatMode(newMode);
  updateToggleUI(newMode);
  
  window.dispatchEvent(new CustomEvent('vat-mode-changed', { detail: { mode: newMode } }));
});

// Initialize - just apply saved mode, no DOM changes
function init() {
  syncActiveColorFromHeader();
  const mode = getEffectiveVatMode();
  if (!isVatToggleEnabled()) {
    localStorage.setItem(STORAGE_KEY, 'incl');
  }
  applyVatMode(mode);
  updateToggleUI(mode);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
